'use client';

import { useEffect } from 'react';

import { initGoogleAds } from '~/lib/analytics/gtag';

interface GoogleAdsScriptProps {
  conversionId: string | undefined;
}

/**
 * Client component that initializes the Google Ads gtag.js script on mount.
 *
 * Renders nothing visible. Loads the gtag script only when a conversionId
 * is provided, ensuring no cross-vertical pollution and no loading on pages
 * without Google Ads configured.
 */
export function GoogleAdsScript({ conversionId }: GoogleAdsScriptProps) {
  useEffect(() => {
    initGoogleAds(conversionId);
  }, [conversionId]);

  return null;
}
